var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view login"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half is-offset-one-quarter"},[_c('div',{staticClass:"box"},[_c('LoginForm',{attrs:{"version":_vm.version}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }